import { ApiError } from "../lib/auth";

/**
 * WHAT A REFUSED GENERATE SAYS (HOTFIX 2026-11-03). A non-2xx from job create used to become
 * "We couldn't start the build … job (no id)": the server's own sentence was thrown away, and there
 * is no job id on a refusal by definition. Now the agent reads the server's reason in plain words,
 * plus the request id support can find in the logs ("Reference 7b9ce1e1"). The review is untouched.
 */

/** The server's reason, as a sentence. FastAPI's 422 `detail` is a list of {msg}; a 400 is a string. */
export function serverReason(e: unknown): string | null {
  if (!(e instanceof ApiError)) return null;
  const body = e.body as { detail?: unknown } | null;
  const d = body && typeof body === "object" ? body.detail : undefined;
  if (typeof d === "string" && d.trim()) return d.trim();
  if (Array.isArray(d)) {
    const msgs = d
      .map((x) => (x && typeof x === "object" && typeof (x as { msg?: unknown }).msg === "string"
        ? (x as { msg: string }).msg : null))
      .filter((m): m is string => !!m);
    if (msgs.length) return msgs.join("; ");
  }
  return null;
}

/** The first block of the request id, which is what a person reads out ("7b9ce1e1"). */
export function shortReference(id: string | null | undefined): string | null {
  if (!id) return null;
  const head = id.trim().split("-")[0];
  return head || null;
}

export function buildStartFailure(e: unknown, jobId?: string | null, what: "build" | "voice" = "build"): string {
  const lead = what === "voice"
    ? "We couldn't start that voice. Nothing about the report you already have has changed."
    : "We couldn't start the build. Your review is exactly as you left it.";
  const reason = serverReason(e);
  const ref = shortReference(e instanceof ApiError ? e.requestId : null);
  const parts = [lead];
  if (reason) parts.push(`The server said: ${reason.replace(/\s*$/, "")}${/[.!?]$/.test(reason.trim()) ? "" : "."}`);
  else if (e instanceof ApiError) parts.push(`The server refused the request (error ${e.status}).`);
  const ids = [ref ? `Reference ${ref}` : null, jobId ? `job ${jobId}` : null].filter(Boolean).join(", ");
  parts.push(`${what === "voice" ? "Try again" : "Press Generate again"}; if it fails a second time, send hello@valubrief.ai${ids ? ` ${ids}` : " the time it happened"}.`);
  return parts.join(" ");
}
